<template>
    <li :class="activateClass">
        <a @click.prevent.stop="$emit('activate-tab', item.key)">{{ item.text }}</a>
    </li>
</template>

<script>
	export default {
		name: "ResponsiveTabsListItem",
        props: {
			item: Object,
			activateClass: String,
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/common/tabs/TabsListItem.vue